import PropTypes from 'prop-types';
import React, { useMemo, useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { Card, CardBody, Container, Button, Form, FormGroup, Label, Input, Row, Col, CardHeader } from 'reactstrap';
import { Formik, Field, ErrorMessage, useFormik } from 'formik';
import * as Yup from 'yup';
import { json, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import Spinners from 'components/Common/Spinner';
import * as XLSX from 'xlsx';  // Import the xlsx library
import { checkPermissions } from 'components/Common/ChkPermissions';
import { getUserPendingLiveStickCallsAPIURL, getActiveUserListAPIURL, routeUserLiveStickyCallsAPIURL } from 'BaseComponentAPI/RouteUserPendingStickyLiveCallsAPI';
import CantAccessPage from 'components/Common/CantAccessPage';
import Loader from 'components/Common/Loader';
import Breadcrumbs from "../../components/Common/Breadcrumb";
import TableContainer from 'components/Common/TableContainer';
import PopupWindow from 'components/Common/PopupWindow';
import Select from "react-select";



const RouteUserPendingStickyLiveCalls = (props) => {
    const authUser = useSelector(state => state.Login);
    document.title = "Cockpit";
    const storedPermissions = JSON.parse(localStorage.getItem('permissions')) || {};
    const { canRead, canCreate, canChange } = checkPermissions(storedPermissions);

    const [loaderOption, setLoaderOption] = useState(false);
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');  // Set the message from passed state
    const [popupType, setPopupType] = useState('');  // Set the type from passed state
    const [loadingUsers, setLoadingUsers] = useState(false);
    const [userOptions, setUserOptions] = useState([]);

    const [sourceUser, setSourceUser] = useState(null);
    const [selectedDate, setSelectedDate] = useState("");
    const [selectedCalls, setSelectedCalls] = useState([]);

    // const handleSelectCall = (callUUID) => {
    //     setSelectedCalls((prev) =>
    //         prev.includes(callUUID)
    //         ? prev.filter((id) => id !== callUUID)
    //         : [...prev, callUUID]
    //     );
    // };

    const handleSelectAll = (checked) => {
        if (checked) {
            const allIds = data.map((item) => item.callUUID);
            setSelectedCalls(allIds);
        } else {
            setSelectedCalls([]);
        }
    };

    const handleRowClick = (callUUID) => {
        setSelectedCalls(prev => {
            if (prev.includes(callUUID)) {
            return prev.filter(id => id !== callUUID);
            } else {
            return [...prev, callUUID];
            }
        });
    };

    useEffect(() => {
         getUserList();
        if (sourceUser && selectedDate) {
        handlePageChange();
        }
    }, [sourceUser, selectedDate, authUser]);

    const openPopup = (message, type) => {
        setPopupMessage(message);
        setPopupType(type);
        setIsPopupVisible(true);
    };

    const closePopup = () => {
        setIsPopupVisible(false);
    };

    

   

    const columns = useMemo(
        () => [


            {
                header: (
                    <Input
                    type="checkbox"
                    onChange={(e) => handleSelectAll(e.target.checked)}
                    />
                ),
                accessorKey: "select",
                enableSorting: false,
                cell: ({ row }) => (
                    <Input
                    type="checkbox"                    
                    checked={selectedCalls.includes(row.original.callUUID)}
                    onChange={() => handleRowClick(row.original.callUUID)}
                    />
                )
            },

            {
                header: "Sr No",
                accessorKey: "seqNo",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "User Name",
                accessorKey: "userName",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Call Type",
                accessorKey: "callType",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Call Status",
                accessorKey: "callStatus",
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ cell }) => (cell.getValue() == 1 ? "Attended" : "Unattened"),
            },
            {
                header: "Customer Name",
                accessorKey: "customerName",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Header",
                accessorKey: "header",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Mobile Number",
                accessorKey: "customerMobile",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Scheduled Call Time",
                accessorKey: "callReceivedTime",
                enableColumnFilter: false,
                enableSorting: true,
            },
            

        ],
        [selectedCalls, handleRowClick, handleSelectAll]
    )

    const [data, setData] = useState([]);
    const [submittedCallType, setSubmittedCallType] = useState("");
    const [pageNo, setPageNo] = useState(1);  // Track the current page number
    const [pageSize, setPageSize] = useState(50);  // Track page size
    const [totalPages, setTotalPages] = useState('');
    const [totalItems, setTotalItems] = useState('');
    const [nextPage, setNextPage] = useState('');
    const [previousPage, setPreviousPage] = useState('');
    const [currentPage, setCurrentPage] = useState('');

    // extra fields
    
    const [targetUser, setTargetUser] = useState(null);
    
    const [callList, setCallList] = useState([]);
   
     
    const [loading, setLoading] = useState(false);


    const customePageSize = [50, 75, 100, 150, 200]

    const [disabelSaveBtn, setDisableSaveBtn] = useState(false);



    const today = new Date();

    // Max date = Yesterday
    const maxDate = new Date(today);
    maxDate.setDate(today.getDate() + 4);

    // Min date = 11 days before today
    const minDate = new Date(today);
    minDate.setDate(today.getDate() - 4);

    // Format YYYY-MM-DD
    const formatDate = (date) =>
    date.toISOString().split("T")[0];

    const minDateFormatted = formatDate(minDate);
    const maxDateFormatted = formatDate(maxDate);
    const todaysDateFormatted = formatDate(today);


    
    
    const fetchPendingCalls = async () => {
    try {
        setLoading(true);
        console.log(`${getUserPendingLiveStickCallsAPIURL}?selectedUserUUID=${formik.values.sourceUserSelect.value}&callType=1&isPagination=1&pageNo=${pageNo}&perPageRec=${pageSize}&recordsDate=${formik.values.selectedDate}`);
        const response = await axios.get(
                        `${getUserPendingLiveStickCallsAPIURL}?selectedUserUUID=${formik.values.sourceUserSelect.value}&callType=1&isPagination=1&pageNo=${pageNo}&perPageRec=${pageSize}&recordsDate=${formik.values.selectedDate}`,
                        {
                            headers: { ...authUser.headers },
                            'Authorization': `Bearer ${authUser.headers.access_token}`
                        }
                    );

            if (response.data.responseMsg == "Success") {
                        // console.log(JSON.stringify(response.data))
                        setData(response.data.data.items);
                        setTotalPages(response.data.data.totalPages)
                        setTotalItems(response.data.data.totalItems);
                        setNextPage(response.data.data.nextPage);
                        setPreviousPage(response.data.data.previousPage);
                        setCurrentPage(response.data.data.currentPage);
                        setDisableSaveBtn(false);
                        setLoaderOption(false);
                    } else if (response.data.responseMsg == "Records not found") {
                        console.error('API Response Error:', response.data.responseMsg);
                        setLoaderOption(false);
                        setDisableSaveBtn(false);
                        //openPopup(response.data.responseMsg, 'error');
                    }
                    else {
                        console.error('API Response Error:', response.data.responseMsg);
                        setLoaderOption(false);
                        setDisableSaveBtn(false);
                        //openPopup(response.data.responseMsg, 'error');
                    }
                }
    catch (error) {
                    console.error('Error fetching data:', error);
                    setLoaderOption(false);
                    setDisableSaveBtn(false);
                    //openPopup("Requested Data Not Found / 404", 'warn');
                }
    finally {
                    setLoading(false);
                }        

    };

    //Pagination
    const handlePageChange = async (newPageNo, newPageSize) => {
        if (formik.values.sourceUserSelect) {
            if (authUser.headers && Object.keys(authUser.headers).length > 0) {
                // console.log(`API URL: ${getNewCurrentCallBoardStatusAPIURL}?userUUID=${authUser.headers.userUUID}&callType=${formik.values.callType}&isPagination=1&pageNo=${newPageNo}&perPageRec=${newPageSize}`);
                setLoading(true);
                try {
                    const response = await axios.get(
                        `${getUserPendingLiveStickCallsAPIURL}?selectedUserUUID=${formik.values.sourceUserSelect.value}&callType=1&isPagination=1&pageNo=${newPageNo}&perPageRec=${newPageSize}&recordsDate=${formik.values.selectedDate}`,
                        {
                            headers: { ...authUser.headers },
                            'Authorization': `Bearer ${authUser.headers.access_token}`
                        }
                    );

                    if (response.data.responseMsg == "Success") {
                        // console.log(JSON.stringify(response.data))
                        setCallList(response.data || []);
                        setData(response.data.data.items);
                        setTotalPages(response.data.data.totalPages)
                        setTotalItems(response.data.data.totalItems);
                        setNextPage(response.data.data.nextPage);
                        setPreviousPage(response.data.data.previousPage);
                        setCurrentPage(response.data.data.currentPage);
                        setDisableSaveBtn(false);
                        setLoaderOption(false);
                        setLoading(false);
                    } else {
                        console.error('API Response Error:', response.data.responseMsg);
                        setLoading(false);
                        setLoaderOption(false);
                        setDisableSaveBtn(false);
                        openPopup(response.data.responseMsg, 'error');

                    }
                } catch (error) {
                    console.error('Error fetching data:', error);
                    setLoading(false);
                    setLoaderOption(false);
                    setDisableSaveBtn(false);
                    openPopup(error.message, 'error');

                }
                finally {
                    setLoading(false);
                    setLoaderOption(false);
                 }
            }
        }
    };

    const formik = useFormik({
       
        initialValues: {
            
            sourceUserSelect: null,
            selectedDate: todaysDateFormatted,
            //targetUser: null,
        },
        validationSchema: Yup.object({
            
            selectedDate: Yup.string().required('Date is required'),            
            sourceUserSelect: Yup.object().nullable().required("Source user is required"),
            
        }),
        
        onSubmit: async (values) => {
            setLoaderOption(true);
            setDisableSaveBtn(true);
            setData([]);
            setTotalPages('');
            setPageSize(50);

           

             //console.log('on submit');
             //console.log(values.sourceUserSelect.value);

            if (authUser.headers && Object.keys(authUser.headers).length > 0) {
                //console.log(`API URL: ${getUserPendingLiveStickCallsAPIURL}?selectedUserUUID=${values.sourceUserSelect.value}&callType=1&isPagination=1&pageNo=${pageNo}&perPageRec=${pageSize}&recordsDate=${formik.values.selectedDate}`);
                //console.log(pageSize);
                //console.log(values.selectedDate);
                try {
                    const response = await axios.get(
                        `${getUserPendingLiveStickCallsAPIURL}?selectedUserUUID=${values.sourceUserSelect.value}&callType=1&isPagination=1&pageNo=${pageNo}&perPageRec=${pageSize}&recordsDate=${formik.values.selectedDate}`,
                        {
                            headers: { ...authUser.headers },
                            'Authorization': `Bearer ${authUser.headers.access_token}`
                        }
                    );
                    // console.log(response.data.responseMsg)
                    if (response.data.responseMsg == "Success") {
                        // console.log(JSON.stringify(response.data))
                        setData(response.data.data.items);
                        setTotalPages(response.data.data.totalPages)
                        setTotalItems(response.data.data.totalItems);
                        setNextPage(response.data.data.nextPage);
                        setPreviousPage(response.data.data.previousPage);
                        setCurrentPage(response.data.data.currentPage);
                        setDisableSaveBtn(false);
                        setLoaderOption(false);
                    } else if (response.data.responseMsg == "Records not found") {
                        console.error('API Response Error:', response.data.responseMsg);
                        setLoaderOption(false);
                        setDisableSaveBtn(false);
                        openPopup(response.data.responseMsg, 'error')
                    }
                    else {
                        console.error('API Response Error:', response.data.responseMsg);
                        setLoaderOption(false);
                        setDisableSaveBtn(false);
                        openPopup(response.data.responseMsg, 'error')
                    }
                }
                catch (error) {
                    console.error('Error fetching data:', error);
                    setLoaderOption(false);
                    setDisableSaveBtn(false);
                    openPopup("Requested Data Not Found / 404", 'warn')
                }
                // finally {
                //     setLoaderOption(false);
                // }
            }

        },
    });

    const exportToExcel = async () => {
        setLoaderOption(true);
        if (authUser.headers && Object.keys(authUser.headers).length > 0 && data.length != 0) {
            // console.log( `${getNewCurrentCallBoardStatusAPIURL}?userUUID=${authUser.headers.userUUID}&callType=${formik.values.callType}&isPagination=0&pageNo=0&perPageRec=0`)
            try {
                const response = await axios.get(
                    `${getUserPendingLiveStickCallsAPIURL}?selectedUserUUID=${sourceUser.value}&callType=1&isPagination=0&pageNo=0&perPageRec=0&recordsDate=${formik.values.selectedDate}`,
                    {
                        headers: { ...authUser.headers },
                        'Authorization': `Bearer ${authUser.headers.access_token}`
                    }
                );

                if (response.data.responseMsg == "Success") {
                    const rawData = response.data.data.items; // API response data

                    // Exclude "Action" column
                    const filteredColumns = columns.filter(col => col.header != "Action");

                    // Define headers for Excel
                    const columnHeaders = filteredColumns.map(col => col.header);

                    // Map and transform data based on column definitions
                    const formattedData = rawData.map(item =>
                        filteredColumns.map(col => {
                            const value = item[col.accessorKey] ?? "";

                            // Apply column-specific formatting
                            switch (col.accessorKey) {
                                case "callStatus":
                                    return value == 1 ? "Attended" : "Unattended";
                                default:
                                    return value;
                            }
                        })
                    );

                    // Combine headers and data
                    const sheetData = [columnHeaders, ...formattedData];

                    // Create worksheet and workbook
                    const ws = XLSX.utils.aoa_to_sheet(sheetData);
                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Historic Call Board Records");

                    // Get the current date and time in IST
                    const currentDate = new Date().toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
                    const formattedDate = currentDate.replace(",", "").replace(/\//g, "-").replace(/:/g, "-").split(" ")[0] + " " + currentDate.split(" ")[1];

                    // Set the file name dynamically
                    const fileName = `${submittedCallType}-${formattedDate}.xlsx`;

                    // Export the Excel file
                    XLSX.writeFile(wb, fileName);

                    setLoaderOption(false);
                } else {
                    console.error("API Response Error:", response.data.responseMsg);
                    setLoaderOption(false);
                    openPopup(response.data.responseMsg, "error");
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                setLoaderOption(false);
                openPopup("Requested Data Not Found / 404", 'warn')
            }
        }
    };

    const handleRouteCalls = async () => {
            if (!targetUser) {
                //toast.warning("Select target user");
                openPopup('Select target user!', 'error')
                return;
            }

            if (selectedCalls.length === 0) {
                //toast.warning("Select at least one call");
                openPopup('Select at least one call!', 'error');
                return;
            }

            try {
                setLoading(true);
                console.log('target' + ' - ' + targetUser.value);
                console.log('Source' + ' - ' + formik.values.sourceUserSelect.value);
                console.table(selectedCalls);
                console.log(JSON.stringify({ selectedCallIds: selectedCalls }));

                const response = await axios.patch(`${routeUserLiveStickyCallsAPIURL}`,
                    {
                    sourceUserUUID: formik.values.sourceUserSelect.value,
                    targetUserUUID: targetUser.value,
                    callsCount: selectedCalls.length,
                    callUUIDs: selectedCalls
                    }, 
                    {
                        headers: { ...authUser.headers },
                        'Authorization': `Bearer ${authUser.headers.access_token}`
                    });              
                    
                //console.log(selectedCalls.length);
                //console.log(selectedCalls[0]);
                // await post("/api/routecalls", {
                // fromUserUUID: sourceUser.value,
                // toUserUUID: targetUser.value,
                // callUUIDs: selectedCalls
                // });

                //toast.success("Calls routed successfully");
                setLoading(false);
                if (response.data.responseCode == 0) {
                        openPopup(response.data.responseMsg, 'success');
                
                } else {
                    console.error("API Response Error:", response.data.responseMsg);
                    setLoaderOption(false);
                    openPopup(response.data.responseMsg, "error");
                }

                setSelectedCalls([]);
                setData([]); // Reset the data when the call type changes
                setTargetUser(null);
                fetchPendingCalls(); // refresh list

            } catch (error) {
                
                if (error.response) {
                    const responseMsg = error.response.data.responseMsg;
                    console.error("Error Message:", responseMsg);
                    openPopup(responseMsg, 'error');
                } 
                else {
                    console.error("Error Message:", "Something went wrong. Please contact admin!");
                    openPopup("Something went wrong. Please contact admin!", 'error');                    
                }                
                setLoading(false);
                
            } finally {
                setLoading(false);
            }
    };

    const getUserList = async () => {
        setLoadingUsers(true);

        if (authUser.headers && Object.keys(authUser.headers).length > 0) {
                try {
                    
                const response = await axios.get(
                            `${getActiveUserListAPIURL}?userUUID=${authUser.headers.userUUID}&isPagination=0&pageNo=0&perPageRec=0`,
                            {
                                headers: { ...authUser.headers },
                                'Authorization': `Bearer ${authUser.headers.access_token}`
                            }
                        );        

                if (response?.data?.responseCode === 0) {
                const userOptions =
                    response.data.data.items?.map(user => ({
                    value: user.userUUID,
                    label: `${user.firstName} ${user.lastName} ( ${user.userName} )`,
                    })) || [];

                setUserOptions(userOptions);                
                }
                else
                {
                    console.error('API Response Error:', response.data.responseMsg);
                    //setLoaderOption(false);
                    openPopup('Something went wrong!', 'error')
                }
            } catch (error) {
                console.error("Error fetching telecaller list", error);
                openPopup('Something went wrong!', 'error')
                
            } finally {
                setLoadingUsers(false);
            }
    }
    };


    if (!canRead) {
        return (
            <>
                <React.Fragment>
                    <div className="page-content">
                        <Container fluid>
                            <Breadcrumbs title="Users" breadcrumbItem="Route User Pending Sticky Live Calls" />
                            <CantAccessPage />
                        </Container>
                    </div>
                </React.Fragment>
            </>
        )
    }
    else {
        if (loaderOption == true) {
            return (
                <>
                    <Loader />
                </>
            )
        }
        else {
            return (
                <React.Fragment>
                    <div className="page-content">
                        <Container fluid>
                            <Breadcrumbs title="Users" breadcrumbItem="Route User Pending Sticky Live Calls" />
                            <Card>
                                <CardBody>

                                    <Form onSubmit={formik.handleSubmit}>

                                        <Row className="align-items-end g-3">
                                           
                                        
                                        <Col md={3} sm={6} xs={12}>
                                        <FormGroup>
                                            <Label>Source User</Label>
                                            

                                            <Select
                                                name="sourceUserSelect"
                                                id="sourceUserSelect"
                                                options={userOptions}
                                                value={formik.values.sourceUserSelect}
                                                onChange={(selected) =>{
                                                    formik.setFieldValue("sourceUserSelect", selected);
                                                    setData([]); // Reset the data when the call type changes
                                                    setTargetUser(null);
                                                    //formik.setFieldValue("targetUser", null);                                                    
                                                    //formik.setFieldTouched("targetUser", false);                                                                                                       
                                                }}
                                                onBlur={() =>
                                                    formik.setFieldTouched("sourceUserSelect", true)
                                                }
                                                placeholder="Select Source User"
                                                isClearable
                                                className={
                                                    formik.touched.sourceUserSelect &&
                                                    formik.errors.sourceUserSelect
                                                    ? "is-invalid"
                                                    : ""
                                                }
                                            />

                                                {formik.touched.sourceUserSelect &&
                                                formik.errors.sourceUserSelect && (
                                                    <div className="invalid-feedback d-block">
                                                    {formik.errors.sourceUserSelect}
                                                    </div>
                                                )}    

                                        </FormGroup>
                                        </Col>


                                        {/* <Col md={4}> */}
                                        <Col md={3} sm={6} xs={12}>
                                            <FormGroup>
                                                <Label for="selectedDate">Select Date</Label>
                                                <Input
                                                    type="date"
                                                    name="selectedDate"
                                                    id="selectedDate"
                                                    className="form-control form-control-xs"
                                                    onChange={(e) => {
                                                            formik.handleChange(e);
                                                            setData([]); // Reset the data when the call type changes
                                                            //setPageSize(50);
                                                        }}
                                                    // onChange={formik.handleChange
                                                    // }
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.selectedDate}
                                                    min={minDateFormatted}
                                                    max={maxDateFormatted}
                                                />
                                                {formik.touched.selectedDate && formik.errors.selectedDate ? (
                                                    <div style={{ color: 'red', marginTop: '5px' }}>
                                                        {formik.errors.selectedDate}
                                                    </div>
                                                ) : null}
                                            </FormGroup>
                                        </Col> 

                                        <Col md={3} sm={6} xs={12}>
                                            <FormGroup>
                                                <Label>Target User</Label>
                                               

                                                <Select
                                                    name="targetUser"
                                                    id="targetUser"
                                                    options={userOptions.filter(
                                                        user => user.value !== formik.values.sourceUserSelect?.value
                                                    )}
                                                    value={targetUser}
                                                    onChange={(selected) => setTargetUser(selected)}
                                                    placeholder="Select Target User"
                                                    classNamePrefix="select2-selection"
                                                    isClearable
                                                />

                                                {/* <Select
                                                        name="targetUser"
                                                        options={userOptions}
                                                        value={formik.values.targetUser}
                                                        onChange={(selected) =>
                                                            formik.setFieldValue("targetUser", selected)
                                                        }
                                                        onBlur={() => formik.setFieldTouched("targetUser", true)}
                                                        className={
                                                            formik.touched.targetUser && formik.errors.targetUser
                                                            ? "is-invalid"
                                                            : ""
                                                        }
                                                 />

                                                        {formik.touched.targetUser && formik.errors.targetUser && (
                                                        <div className="invalid-feedback d-block">
                                                            {formik.errors.targetUser}
                                                        </div>
                                                        )} */}


                                                
                                            </FormGroup>
                                        </Col>
                                        </Row>  
                                        
                                          <Col md={4} className="d-flex gap-2"> 
                                          <div className="d-flex gap-2">
                                            <Button color="primary" type="submit" className="me-2" size="xs"  disabled={disabelSaveBtn || !canRead}>
                                                Show Records
                                            </Button>
</div>  
                                            <Button
                                                color="success"
                                                size="xs"
                                                disabled={!selectedCalls.length || !targetUser}
                                                onClick={handleRouteCalls}
                                            >
                                                Route Selected ({selectedCalls.length})
                                            </Button>
                                         </Col>

                                       
                                         
                                    </Form>

                                    {(data.length != 0)
                                        ?
                                        <>

                                            {/* <h5 className="mt-4" style={{ color: '#b72323' }}>
                                                Report for : Current {submittedCallType} Call Status
                                            </h5> */}
                                             <div className="mt-4"></div>

                                            {/* <div className="mb-4">
                                                 <Row className="align-items-center"></Row>
                                                <h5 style={{ color: '#b72323', fontWeight: 600 }}>
                                                    Report for : {submittedCallType} Call Status
                                                </h5>
                                                <div style={{ fontSize: "14px", color: "#6c757d" }}>
                                                    Date : {formik.values.selectedDate}
                                                </div>
                                            </div> */}

                                            <div className="mt-4">

                                                <Row className="align-items-center">

                                                    {/* Report Heading */}
                                                    <Col md={8} sm={8} xs={12}>
                                                    <div>
                                                        <h5 style={{ color: '#b72323', fontWeight: 600 }}>
                                                        Report for : {submittedCallType} System Call Board
                                                        </h5>
                                                         <hr className="my-3" />
                                                        <div style={{ fontSize: "14px", color: "#6c757d" }}>
                                                        Date : {formik.values.selectedDate}
                                                        </div>
                                                    </div>
                                                   
                                                    </Col>

                                                    {/* Export Button */}
                                                    {/* <Col md={4} sm={4} xs={12} className="text-md-end mt-3 mt-md-0">
                                                    <button
                                                        color="success"
                                                        size="sm"
                                                        onClick={exportToExcel}
                                                        className="btn btn-primary me-1"
                                                    >
                                                        Export Excel
                                                    </button>
                                                    </Col> */}

                                                </Row>

                                            </div>


                                            <div className='mt-3'>
                                                {/* <div className="d-flex align-items-center justify-content-end mb-2">
                                                    <div className="flex-shrink-0">
                                                        <button
                                                            onClick={exportToExcel}  // Trigger the export function
                                                            className="btn btn-primary me-1"
                                                        >
                                                            Export Excel
                                                        </button>
                                                    </div>
                                                </div> */}
                                                <TableContainer
                                                    columns={columns}
                                                    data={data || []}
                                                    isGlobalFilter={true}
                                                    isPagination={true}
                                                    SearchPlaceholder="Search..."
                                                    isCustomPageSize={true}
                                                    tableClass="align-middle table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                                    theadClass="table-light"
                                                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                                    pagination="pagination"
                                                    getRowProps={row => ({
                                                        className: `${row.original.callStatus == 0 ? "is-receivable" : ""
                                                            }`,
                                                    })}
                                                    onPageChange={handlePageChange} // Pass page change handler
                                                    onPageSizeChange={handlePageChange} // Pass page size change handler
                                                    pageSize={pageSize}
                                                    setPageSize={setPageSize}
                                                    totalPages={totalPages}
                                                    totalItems={totalItems}
                                                    tableNextPage={nextPage}
                                                    tablePreviousPage={previousPage}
                                                    tableCurrentPage={currentPage}
                                                    customePageSize={customePageSize}
                                                />
                                            </div>
                                        </>
                                        :
                                        ''
                                    }



                                </CardBody>
                            </Card>
                        </Container>
                    </div>

                    {isPopupVisible && (
                        <PopupWindow message={popupMessage} type={popupType} onClose={closePopup} />
                    )}
                </React.Fragment >
            );
        }
    }
};

RouteUserPendingStickyLiveCalls.propTypes = {
    t: PropTypes.any,
};

export default withTranslation()(RouteUserPendingStickyLiveCalls);

